var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBurgerButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 28,
    viewBox: "0 0 32 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    transform: "translate(-13 -30.822)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    width: 32,
    height: 6,
    rx: 3,
    transform: "translate(13 30.822)",
    fill: "#00aeef"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    width: 32,
    height: 6,
    rx: 3,
    transform: "translate(13 41.822)",
    fill: "#105dae"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    width: 32,
    height: 6,
    rx: 3,
    transform: "translate(13 52.822)",
    fill: "#21409a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBurgerButton);
export default __webpack_public_path__ + "static/media/burger_button.13c0a9a26324aaca5369455a189f6774.svg";
export { ForwardRef as ReactComponent };